module.exports = __webpack_public_path__ + "img/6.23b363a4.png";